import Link from 'next/link';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import useI18n from '../../common/hooks/useI18n';

import { ButtonTextAnchor } from './header';
import { HeaderDropdownProps } from './headerDropdown';

const HeaderDropdownClient: React.FC<HeaderDropdownProps> = ({
  items,
  containerId,
  buttonHref,
  buttonTextKey,
  buttonPrimary = false,
}) => {
  const i18n = useI18n();

  return (
    <Dropdown
      menu={{
        items,
      }}
      overlayClassName="no-opacity-dropdown"
      getPopupContainer={() => document.getElementById(containerId)}
    >
      <Button
        type={buttonPrimary ? 'primary' : 'text'}
        onClick={(e) => e.preventDefault()}
      >
        <span>
          <Link href={buttonHref} passHref legacyBehavior>
            <ButtonTextAnchor
              as="a"
              className="ant-dropdown-trigger"
              $primary={buttonPrimary}
            >
              {i18n.t(buttonTextKey)}
            </ButtonTextAnchor>
          </Link>
        </span>
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default HeaderDropdownClient;
